import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ListOfReturnsRequests } from '../../../components/admin-dashboard-component/Return Requests/list-of-returns-requests/list-of-returns-requests';

@Component({
  selector: 'app-return-of-requests-list',
  imports: [ListOfReturnsRequests],
  templateUrl: './return-of-requests-list.html',
  styleUrl: './return-of-requests-list.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReturnOfRequestsList {}
